import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ExecucaoOrcamentaria } from '../models/execucao-orcamentaria.model';

@Injectable({
  providedIn: 'root',
})
export class ExecucaoOrcamentariaService extends BaseService<ExecucaoOrcamentaria> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getIndicadoresList(id: number): Observable<ExecucaoOrcamentaria[]> {
    return this.http.get<ExecucaoOrcamentaria[]>(this.baseUrl + '/indicador-list/' + id, { headers: this.headers });
  }

  public getEntregasList(id: number): Observable<ExecucaoOrcamentaria[]> {
    return this.http.get<ExecucaoOrcamentaria[]>(this.baseUrl + '/entrega-list/' + id, { headers: this.headers });
  }

  public alterAno(obj: any, id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/alterar-ano/' + id, obj, { headers: this.headers });
  }

  public getConfigList(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/configurar/' + id, { headers: this.headers });
  }

  public configUpdate(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/configurar/' + id, obj, { headers: this.headers });
  }

  public getPermission(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/permission/' + id, { headers: this.headers });
  }

  public getItensList(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/itens-list/' + id, { headers: this.headers });
  }

  public itensUpdate(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/itens/' + id, obj, { headers: this.headers });
  }

  public getLoaList(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/loa-list/' + id, { headers: this.headers });
  }

  public loaUpdate(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/loa/' + id, obj, { headers: this.headers });
  }

  public loaDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/loa/' + id, { headers: this.headers });
  }

  public loaDeleteMultiple(ids: number[]): Observable<any> {
    return this.http.post(this.baseUrl + '/loa/delete-multiple', { ids: ids }, { headers: this.headers });
  }

  public loaFpeFilters(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/loa-fpe-filters', obj, { headers: this.headers });
  }

  public loaFpeSearch(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/loa-fpe-search', obj, { headers: this.headers });
  }

  public loaFpeCreate(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/loa-fpe', obj, { headers: this.headers });
  }

  public getExcucaoList(obj: any, id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/execucao-list/' + id, obj, { headers: this.headers });
  }

  public execucaoUpdate(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/execucao/' + id, obj, { headers: this.headers });
  }

  public previsaoUpdate(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/previsao/' + id, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/execucao-orcamentaria';
  }

}
